module.exports = __webpack_public_path__ + "img/15-twoImg.3aa35774.png";